import request from '@/utils/request'

// 查询列表
export function apiMdmUomConversionsList (query) {
  return request({
    url: '/mdm/mdmUomConversions/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apidMUomConversionsNewExport (data) {
  return request({
    url: '/mdm/mdmUomConversions/v2/export',
    method: 'post',
    data: data
  })
}

// 单位
export function apiMdmUomUnitsOfMeasureUnitOfMeasureList (query) {
  return request({
    url: '/mdm/mdmUomUnitsOfMeasure/unitOfMeasureList',
    method: 'get',
    params: query
  })
}

// 来源分类带出，来源单位和基本单位
export function apiMdmUomConversionsClassToData (query) {
  return request({
    url: '/mdm/mdmUomConversions/classToData',
    method: 'get',
    params: query
  })
}

// 新增
export function apiMdmUomConversionsAdd (data) {
  return request({
    url: '/mdm/mdmUomConversions',
    method: 'post',
    data: data
  })
}

// 修改
export function apiMdmUomConversionsUpdate (data) {
  return request({
    url: '/mdm/mdmUomConversions',
    method: 'put',
    data: data
  })
}
